import { api } from "shared/api";
import { ApiResponse } from 'shared/model/types';
const confirmEmailApi = api.injectEndpoints({
  endpoints: build => ({
    sendEmailCode: build.query<ApiResponse<unknown>, void>({
      query: () => {
        return {
          url: '/user/private/resend-token',
          method: 'GET',
        };
      }
    }),
    confirmEmailCode: build.mutation<ApiResponse<unknown>, { code: string }>({
      query: ({ code }) => {
        return {
          url: `/user/confirm/${code}`,
          method: 'POST',
        };
      },
    }),
  })
});
export const { useConfirmEmailCodeMutation, useSendEmailCodeQuery } = confirmEmailApi;